import { createAction } from 'redux-actions';
import { UNDO_STEP, REDO_STEP, CREATE_SNAPSHOT } from '@/constants/index';
import { setProjectToStorage } from '@/helpers';

export const createSnapshot = () => createAction(CREATE_SNAPSHOT, () => {})();

const undoStep = () => createAction(UNDO_STEP, () => {})();

const redoStep = () => createAction(REDO_STEP, () => {})();

export const undoStepThunk = () => (dispatch, getState) => {
  const { core: { snapshotPointer } } = getState();
  const isUndoAvailable = snapshotPointer >= 0;

  if (isUndoAvailable) {
    dispatch(undoStep());
    dispatch(setProjectToStorage());
  }
};

export const redoStepThunk = () => (dispatch, getState) => {
  const { core: { snapshots, snapshotPointer } } = getState();
  const isRedoAvailable = snapshots.length > snapshotPointer + 1;

  if (isRedoAvailable) {
    dispatch(redoStep());
    dispatch(setProjectToStorage());
  }
};

let timer = null;

export const createSnapshotThunk = (payload = {}) => (dispatch, getState) => {
  const { isUndoable = true, saveToStorage = true } = payload;

  if (isUndoable) {
    dispatch(createSnapshot());
  }
  
  if (saveToStorage) {
    clearTimeout(timer);
    timer = setTimeout(() => dispatch(setProjectToStorage()), 1000);
  }
};